<form [formGroup]="form" autocomplete="off" class="minclt-form-print"
	[ngClass]="{ 'ng-invalid ng-dirty': form.invalid && (form.dirty || form.touched) }">
	<div class="p-formgrid grid">
		<ng-content select="[header]"></ng-content>
		<ng-container *ngFor="let question of questions; let i = index">
			<div *ngIf="question.show" [ngClass]="question.col ? question.col : 'col-12 py-2'">
				<div *ngIf="(question.typeInput === 'input' || questions.typeInput === 'password') && question.show"
					class="field p-fluid">
					<label *ngIf="!formFilter"
						class="font-semibold overflow-hidden white-space-nowrap text-overflow-ellipsis"
						[htmlFor]="question.key">{{ question.label }}</label>
					<input *ngIf="question.type === 'text'" [id]="question.key" pInputText matInput
						[placeholder]="question.label" [formControlName]="question.key"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }"
						(blur)="onChangeSingleSelect.emit({ value: $event.target.value, key: question.key, selectedField: i })">
					<p-inputNumber *ngIf="question.type === 'number'" [id]="question.key" [inputId]="question.key"
						[placeholder]="question.label" [formControlName]="question.key" [mode]="'decimal'"
						[locale]="'es-CO'" [prefix]="question.showCurrency ? 'COP ' : ''"
						[minFractionDigits]="question.mode === 'decimal' ? 2 : 0"
						[maxFractionDigits]="question.mode === 'decimal' ? 2 : 0" [format]="true" [useGrouping]="true"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }"
						(onInput)="handleInputNumber($event, question)" />
					<p-inputNumber *ngIf="question.type === 'porcentaje'" [id]="question.key" [inputId]="question.key"
						[placeholder]="question.label" [formControlName]="question.key" [mode]="'decimal'" [min]="0"
						[max]="100" [minFractionDigits]="0" [maxFractionDigits]="0" [format]="true" [showButtons]="true"
						[suffix]="'%'" [useGrouping]="false"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }"
						(onInput)="handleInputNumber($event, question)" />
					<p-password *ngIf="question.type === 'password'" [id]="question.key" [toggleMask]="true"
						[formControlName]="question.key" [feedback]="false" [placeholder]="question.label"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }" />
					<textarea *ngIf="question.type === 'textarea'" [id]="question.key" rows="3"  pInputTextarea
						[formControlName]="question.key" [autoResize]="true" [style.min-height.!important]="'78px'"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }">
					</textarea>
					<p-editor *ngIf="question.type === 'html' && !question.readonly" [formControlName]="question.key"
						[style]="{ height: '320px' }" />
					<div *ngIf="question.type === 'html' && question.readonly" [innerHTML]="question.value"></div>
					<small *ngIf="isInvalid(question.key)" style="color: #b00020;">
						<span *ngIf="form.controls[question.key].errors.required">
							El campo es requerido
						</span>
						<span *ngIf="form.controls[question.key].errors.minlength">
							Mínimo de caracteres invalido
						</span>
						<span *ngIf="form.controls[question.key].errors.maxlength">
							Maximo de caracteres invalido
						</span>
						<span *ngIf="form.controls[question.key].errors.email">
							Email invalido
						</span>
						<span *ngIf="form.get(question.key)?.hasError('fieldsMismatch')">
							Los valores no coinciden
						</span>
					</small>
					<small *ngIf="isMaxLengthReached(question) && question.type === 'number'" class="morado">
						<span>
							<strong>Máximo {{ question.rules?.maxLength }} dígitos permitidos.</strong>

						</span>
					</small>

				</div>
				<div *ngIf="question.typeInput === 'select'" class="field p-fluid">
					<label *ngIf="!formFilter"
						class="font-semibold overflow-hidden white-space-nowrap text-overflow-ellipsis"
						[htmlFor]="question.key">{{ question.label }}</label>
					<p-dropdown *ngIf="question.type === 'simple_select'" [id]="question.key"
						[formControlName]="question.key" [options]="question.options" optionLabel="text"
						[filter]="question.filter" [editable]="question.editable" [placeholder]="question.label" optionValue="value"
						[styleClass]="'custom-dropdown'" [ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }"
						(onChange)="onChangeSingleSelect.emit({ value: $event.value, key: question.key, selectedField: i})"
						appendTo="body">
					</p-dropdown>
					<p-multiSelect *ngIf="question.type === 'multiselect'" [id]="question.key" [options]="question.options"
						[formControlName]="question.key" optionLabel="text" optionValue="value"
						[placeholder]="question.label" [ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }"
						(onPanelHide)="handleOverlayClose(question,  i)" appendTo="body">
						<ng-template *ngIf="question.customizeSelect" let-item pTemplate="item">
							<div [pTooltip]="item.text">
								{{ item.text | truncate: question.truncateValue }}
							</div>
						</ng-template>
					</p-multiSelect>
					<small *ngIf="isInvalid(question.key)" style="color: #b00020;">
						<span *ngIf="form.controls[question.key].errors.required">
							El campo es requerido
						</span>
					</small>
				</div>
				<div *ngIf="question.typeInput === 'date'" class="field p-fluid">
					<label *ngIf="!formFilter"
						class="font-semibold overflow-hidden white-space-nowrap text-overflow-ellipsis"
						[htmlFor]="question.key">{{ question.label }}</label>
					<p-calendar [iconDisplay]="'input'" [showIcon]="true" [inputId]="question.key"
						[formControlName]="question.key" [selectionMode]="question.type" [readonlyInput]="true"
						[placeholder]="question.label" [minDate]="question.minDate" [maxDate]="question.maxDate"
						dateFormat="dd/mm/yy" [ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }"
						appendTo="body"
						(onSelect)="onChangeValueDateField.emit({ value: $event, key: question.key, selectedField: i })" />

					<small *ngIf="isInvalid(question.key)" style="color: #b00020;">
						<span *ngIf="form.controls[question.key].errors.required">
							El campo es requerido
						</span>
					</small>
				</div>
				<div *ngIf="question.typeInput === 'file'" class="field p-fluid">
					<label class="font-semibold overflow-hidden white-space-nowrap text-overflow-ellipsis"
						[htmlFor]="question.key">{{ question.label }}</label>
					<p-fileUpload styleClass="w-full" [id]="question.key" (onSelect)="onSelectFileToByField($event, question.key)"
						mode="basic" [chooseLabel]="question.label" uploadLabel="Subir archivo"
						chooseIcon="pi pi-upload" name="file" [accept]="question.accept" />
					<small *ngIf="isInvalid(question.key)" style="color: #b00020;">
						<span *ngIf="form.controls[question.key].errors.required">
							El campo es requerido
						</span>
					</small>
				</div>
				<div *ngIf="question.typeInput === 'check'"
					class="field p-fluid h-full flex flex-column justify-content-between align-items-center"
					style="max-height: 54px;">
					<label class="font-semibold text-center" [htmlFor]="question.key" style="font-size: 9px;">
						{{ question.label }}</label>
					<p-checkbox [formControlName]="question.key" [id]="question.key" binary="true"></p-checkbox>
				</div>
				<div *ngIf="question.typeInput === 'toggle'" class="field p-fluid h-full flex gap-3 align-items-center"
					style="max-height: 150px;">
					<label class="font-semibold text-left" [htmlFor]="question.key" style="margin-bottom: 0;">
						{{ question.label }}</label>
					<p-toggleButton [formControlName]="question.key" onLabel="Sí" offLabel="No"
						(onChange)="onChangeSingleSelect.emit({ value: $event.checked, key: question.key, selectedField: i})" />
				</div>
			</div>
		</ng-container>
		<div *ngIf="formFilter && showButtonsSubmit" class="col-12 md:col-2 p-fluid">
			<p-button [label]="textButtonSubmit" (click)="submitForm()"></p-button>
		</div>

		<ng-content select="[footer]"></ng-content>

		<div *ngIf="showClearFilters" class="col-12 md:col-1 p-fluid">
			<app-boton-svg [nombre]="'restaurar'" [color]="'amarillo'" [size]="'35'" [borderRadius]="'8'"
				(click)="onClickClearFiltersForm()" [pTooltip]="'Limpiar busqueda'"
				tooltipPosition="bottom"></app-boton-svg>
		</div>
	</div>
	<div *ngIf="!formFilter && showButtonsSubmit" class="flex justify-content-end gap-2 mt-5">
		<p-button label="Cancelar" severity="secondary" (click)="cancelQuestions.emit()"></p-button>
		<p-button [label]="textButtonSubmit" (click)="submitForm()"></p-button>
	</div>
</form>